import React from 'react';
import { FaBusinessTime } from 'react-icons/fa';

import hero from '../Assets/AdobeStock_439136266-scaled.jpeg';
const FormationTemplate = ({ module }) => {
	return (
		<div className='w-full h-auto flex flex-col items-center justify-center'>
			<div
				className='p-6 md:p-12 w-full md:w-[80%] bg-white text-black flex flex-col md:flex-row gap-6 items-center justify-center  bg-cover bg-center'
				style={{
					backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0.7) 60%, rgba(255, 255, 255, 0.5) 80%), url(${hero})`
				}}
			>
				<div className=' w-full md:w-[70%]  border bg-white  border-[#87152B] py-4 px-6 rounded-2xl shadow-xl'>
					<h1 className='text-xl md:text-2xl font-bold text-[#87152B] mb-4'>
						{module.title}
					</h1>

					<ol className='list-decimal ml-6 md:ml-8 space-y-4'>
						{module.subFormations.map((item, index) => (
							<li
								key={index}
								className='flex items-start space-x-2 text-sm md:text-xl text-[#87152B]'
							>
								<span className='mt-1 text-[#87152B]'>
									{/* Add an icon here, e.g., a checkmark */}
									<svg
										xmlns='http://www.w3.org/2000/svg'
										fill='none'
										viewBox='0 0 24 24'
										strokeWidth={2}
										stroke='currentColor'
										className='w-6 h-6'
									>
										<path
											strokeLinecap='round'
											strokeLinejoin='round'
											d='M5 13l4 4L19 7'
										/>
									</svg>
								</span>
								<span>{item}</span>
							</li>
						))}
					</ol>
				</div>

				<p className='text-lg flex bg-white flex-row items-center justify-center mb-6 gap-6 border  border-[#87152B] py-8 px-6 rounded-2xl shadow-xl w-[70%] md:w-[30%] p-4'>
					<FaBusinessTime size={60} />
					<span className='text-2xl md:text-7xl  '>
						{module.duration} jour
					</span>
				</p>
			</div>
		</div>
	);
};

export default FormationTemplate;
